// extracted by mini-css-extract-plugin
export default {"avatarMenu":"style_avatarMenu__ycL-9"};